import { Text, VStack, RichText, useTheme } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../../../i18n';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import CompanyLogo from '../../../../common/src/components/CompanyLogo';
import { hasRichText } from '../../../utils/textUtils';

const WelcomeHeader: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { userLang } = useLocale();

  const { distribution } = useAuth();
  const introText =
    distribution?.localized_intro?.[userLang] || distribution?.intro;

  return (
    <VStack spacing="6" align="stretch">
      <CompanyLogo />
      <VStack spacing="6">
        <Text textStyle="smallBody" color="text.gray">
          {t('COMPANY-SCAN_INTRO-TO-OFFICE_START_DESCRIPTION')}
        </Text>

        {introText && hasRichText(introText) && (
          <VStack spacing="2" align="stretch">
            <Text textStyle="h6Headline" textAlign="center">
              {t('COMPANY-SCAN_INTRO-TO-OFFICE_ABOUT-DISTRIBUTION', {
                distribution: distribution?.name,
              })}
            </Text>
            <RichText color={colors.text.gray} value={introText} />
          </VStack>
        )}
      </VStack>
    </VStack>
  );
};

export default WelcomeHeader;
